// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * cm-coding: Global administrators edit prompt rules that affect analysis
 * across applications on this system page. The route supplies the shared
 * administration background and page heading, while the schema catalog
 * supplies the rule editor; keeping that split prevents global navigation and
 * permissions from leaking into the reusable editor.
 */
import { SystemPromptsPanel } from '@/subsystems/schema-catalog';

export default function SystemPromptsPage() {
  return (
    <div className="min-h-full bg-slate-50 text-slate-900">
      <div className="mx-auto max-w-[1280px] px-6 pt-9 pb-16 sm:px-10">
        <h1
          className="text-[21px] font-[650] tracking-[-0.015em]"
          data-testid="system-prompts-page-heading"
        >
          System Prompts
        </h1>
        <p className="mt-[5px] text-[13px] text-slate-500">
          Global rules added to the AI&apos;s instructions in specific situations, platform-wide.
          Leave a rule blank to use the built-in default.
        </p>
        <div className="mt-6">
          <SystemPromptsPanel />
        </div>
      </div>
    </div>
  );
}
